import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5342 1.22171L24.2831 12.9706L12.9694 24.2843L1.2205 12.5354L1.65565 1.65685L12.5342 1.22171Z",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "8.14062",
      cy: "7.55664",
      r: "1",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }